import { apiFetch } from "../Utils/ApiClient";
const source_id = Number(process.env.REACT_APP_SOC_ID || 1);

export const getCountry = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/countries`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getCountry:', error);
      throw error;
    }
  };
};

export const getRelation = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/relations`, { method: 'GET' });
    //   dispatch(individualGetCountry(val.data));
      return val;
    } catch (error) {
      console.error('Error in getRelation:', error);
      throw error;
    }
  };
};

export const getTypeOfTransaction = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/get-transactions-list`, { method: 'GET' });
      //   dispatch(individualGetCountry(val.data));
      return val;
    } catch (error) {
      console.error('Error in getTypeOfTransaction:', error);
      throw error;
    }
  };
};

export const getOccupation = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/get-occupations`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getOccupation:', error);
      throw error;
    }
  };
};

export const getQuotePersonalAccident  = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/get-quotation/personal-accident`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getQuote:', error);
      throw error;
    }
  };
};

export const addPolicyPersonalAccident = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/add-policy/personal-accident`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in addPolicy:', error);
      throw error;
    }
  };
};

export const getPolicyDetailsPersonalAccident = (policyNo) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-policy/${policyNo}`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getIndividualPlanOptions:', error);
      throw error;
    }
  };
};

export const uploadDocumentLife = (data,policyNo) => {
  return async (dispatch) => {
    try {
      // data should be a FormData object
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/life/policy-document/${policyNo}`,
        {
          method: 'POST',
          body: data, 
        }
      );

      return val;
    } catch (error) {
      console.error('Error in uploadDocument:', error);
      throw error;
    }
  };
};

export const getQuestionsPersonalAccident = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/personal-accident/questions`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getIndividualPlanOptions:', error);
      throw error;
    }
  };
};

export const getPersonalAccidentPremium = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/personal-accident/premium`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in getIndividualPlanOptions:', error);
      throw error;
    }
  };
};

export const getPolicyDocuments = (policyNo) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/life/policy-documents/${policyNo}`, { method: 'GET' });
      return val;
    } catch (error) {
      console.error('Error in get life document:', error);
      throw error;
    }
  };
};

export const uploadDocumentLogs = (data,transId) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/life/quotes/uploadDocument/${transId}`,
        {
          method: "PUT",
          body: data,
        }
      );

      return val;
    } catch (error) {
      console.error("Error in uploadDocument:", error);
      throw error;
    }
  };
};

export const uploadPolicyDocumentLogs = (data,transId) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/life/quotes/uploadPolicyPdfDocument/${transId}`,
        {
          method: "PUT",
          body: data,
        }
      );

      return val;
    } catch (error) {
      console.error("Error in uploadDocument:", error);
      throw error;
    }
  };
};

export const sendOTPRequest = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/otp/internal-send`,
        {
          method: "POST",
         body: JSON.stringify(data),
          headers: { "Content-Type": "application/json" },
        }
      );

      return val;
    } catch (error) {
      console.error("Error in sendOTP:", error);
      throw error;
    }
  };
};